module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Crop-92da124332e1b291295466991bef5b15c887ffea5288d4b9c58a583dbd921179.svg";